import React from 'react';
import { Link } from 'react-router-dom';
import CasesAPI from 'api/CasesAPI';
import { formatDate } from 'utils/dateFormater';

interface ISingleResultRow {
    key?: number;
    ticket: any;
    trigger: boolean;
    setTrigger: any;
    setSelectedCase: any;
    setShareModal: any;
  }


const AuditRows: React.FC<ISingleResultRow> = ({ key, ticket, trigger, setTrigger, setSelectedCase, setShareModal }) => {
  const favoriteTicket = async() => {
    const update: any = {
      _id: ticket._id,
      favorite: !ticket.favorite
    };
    await CasesAPI.updateCase(update);
    setTrigger(!trigger);
  };

  return (
    <div className='screening-results-row' key={key} >
      <div className='screening-results-row-default-cell'>
        <div
          className='screening-results-row-default-cell-inner'
        >
          <Link to={{
            pathname: `/monitor/ticket/${ticket._id}`,
          }}>
            <div className='screening-results-row-link-cell-text'>
              {ticket.ticketName}
            </div>
          </Link>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {ticket.docType}
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '5px',
            }}>
            {ticket.curTotal ? ticket.curTotal : '0'}
            {ticket.curNew > 0 &&
            <div className='screening-results-row-default-cell-plus'>
              <div className='screening-results-row-default-cell-plus-number'>
                {ticket.curNew}
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            <svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8' fill='none' style={{ marginRight: '5px' }}>
              <circle cx='4' cy='4' r='3' fill={ticket.status === 'Complete' ? '#BDBEC1' : ticket.status === 'Pending' ? '#FDB022' : ticket.status === 'New Results' ? '#4895EF' : ticket.status === 'Approved' ? '#47CD89' : ticket.status === 'Rejected' ? '#F04438' : '#B67DFF' }/>
            </svg>
            {ticket.status}
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {ticket.lastUpdate ? formatDate(ticket.lastUpdate) : formatDate(ticket.createdAt.substring(0, 10))}
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text' >
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '5px',
            }}>
              <div onClick={favoriteTicket}>
                {ticket.favorite ?
                  <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
                    <path d='M9.65205 2.8778C9.84412 2.48869 9.94015 2.29413 10.0705 2.23197C10.184 2.17789 10.3157 2.17789 10.4292 2.23197C10.5595 2.29413 10.6556 2.48869 10.8477 2.8778L12.6699 6.56944C12.7266 6.68432 12.7549 6.74176 12.7964 6.78635C12.8331 6.82584 12.8771 6.85783 12.9259 6.88056C12.9811 6.90623 13.0445 6.91549 13.1713 6.93402L17.2473 7.5298C17.6766 7.59253 17.8912 7.6239 17.9905 7.72874C18.0769 7.81995 18.1175 7.94529 18.1011 8.06985C18.0822 8.21302 17.9268 8.36436 17.6161 8.66702L14.6677 11.5387C14.5758 11.6282 14.5298 11.673 14.5002 11.7263C14.4739 11.7734 14.4571 11.8252 14.4506 11.8788C14.4433 11.9393 14.4541 12.0025 14.4758 12.129L15.1715 16.1851C15.2448 16.6129 15.2815 16.8269 15.2126 16.9538C15.1526 17.0642 15.046 17.1417 14.9224 17.1646C14.7804 17.1909 14.5883 17.0899 14.2041 16.8879L10.5602 14.9716C10.4466 14.9119 10.3898 14.882 10.33 14.8703C10.2771 14.8599 10.2226 14.8599 10.1697 14.8703C10.1099 14.882 10.0531 14.9119 9.93955 14.9716L6.29561 16.8879C5.91143 17.0899 5.71935 17.1909 5.57731 17.1646C5.45374 17.1417 5.34711 17.0642 5.28712 16.9538C5.21817 16.8269 5.25486 16.6129 5.32823 16.1851L6.02391 12.129C6.0456 12.0025 6.05644 11.9393 6.0491 11.8788C6.04261 11.8252 6.02576 11.7734 5.99951 11.7263C5.96986 11.673 5.9239 11.6282 5.83199 11.5387L2.88364 8.66702C2.57289 8.36436 2.41752 8.21302 2.39861 8.06985C2.38216 7.94529 2.4228 7.81995 2.50921 7.72874C2.60853 7.6239 2.82315 7.59253 3.25237 7.5298L7.32843 6.93402C7.45519 6.91549 7.51857 6.90623 7.57377 6.88056C7.62264 6.85783 7.66664 6.82584 7.70333 6.78635C7.74476 6.74176 7.77311 6.68432 7.82982 6.56944L9.65205 2.8778Z' fill='#4895EF' stroke='#4895EF' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg> :
                  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <g id='star-01'>
                      <path id='Icon' d='M9.40253 2.8778C9.59461 2.48869 9.69064 2.29413 9.82102 2.23197C9.93445 2.17789 10.0662 2.17789 10.1797 2.23197C10.31 2.29413 10.4061 2.48869 10.5981 2.8778L12.4204 6.56944C12.4771 6.68432 12.5054 6.74176 12.5469 6.78635C12.5836 6.82584 12.6276 6.85783 12.6764 6.88056C12.7316 6.90623 12.795 6.91549 12.9218 6.93402L16.9978 7.5298C17.427 7.59253 17.6417 7.6239 17.741 7.72874C17.8274 7.81995 17.868 7.94529 17.8516 8.06985C17.8327 8.21302 17.6773 8.36436 17.3666 8.66702L14.4182 11.5387C14.3263 11.6282 14.2803 11.673 14.2507 11.7263C14.2244 11.7734 14.2076 11.8252 14.2011 11.8788C14.1937 11.9393 14.2046 12.0025 14.2263 12.129L14.922 16.1851C14.9953 16.6129 15.032 16.8269 14.9631 16.9538C14.9031 17.0642 14.7965 17.1417 14.6729 17.1646C14.5308 17.1909 14.3388 17.0899 13.9546 16.8879L10.3106 14.9716C10.1971 14.9119 10.1403 14.882 10.0805 14.8703C10.0276 14.8599 9.97311 14.8599 9.92015 14.8703C9.86034 14.882 9.80358 14.9119 9.69004 14.9716L6.0461 16.8879C5.66192 17.0899 5.46984 17.1909 5.3278 17.1646C5.20423 17.1417 5.09759 17.0642 5.03761 16.9538C4.96866 16.8269 5.00535 16.6129 5.07872 16.1851L5.7744 12.129C5.79609 12.0025 5.80693 11.9393 5.79959 11.8788C5.7931 11.8252 5.77625 11.7734 5.75 11.7263C5.72034 11.673 5.67439 11.6282 5.58248 11.5387L2.63413 8.66702C2.32338 8.36436 2.168 8.21302 2.1491 8.06985C2.13265 7.94529 2.17329 7.81995 2.2597 7.72874C2.35902 7.6239 2.57363 7.59253 3.00286 7.5298L7.07892 6.93402C7.20568 6.91549 7.26906 6.90623 7.32426 6.88056C7.37313 6.85783 7.41713 6.82584 7.45381 6.78635C7.49525 6.74176 7.5236 6.68432 7.5803 6.56944L9.40253 2.8778Z' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                    </g>
                  </svg>}
              </div>
              <div onClick={() => {
                setSelectedCase(ticket);
                setShareModal(true);
              }} style={{ cursor: 'pointer' }}>
                <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <g id='share-07'>
                    <path id='Icon' d='M7.15833 11.2582L12.85 14.5748M12.8417 5.42484L7.15833 8.7415M17.5 4.1665C17.5 5.54722 16.3807 6.6665 15 6.6665C13.6193 6.6665 12.5 5.54722 12.5 4.1665C12.5 2.78579 13.6193 1.6665 15 1.6665C16.3807 1.6665 17.5 2.78579 17.5 4.1665ZM7.5 9.99984C7.5 11.3805 6.38071 12.4998 5 12.4998C3.61929 12.4998 2.5 11.3805 2.5 9.99984C2.5 8.61913 3.61929 7.49984 5 7.49984C6.38071 7.49984 7.5 8.61913 7.5 9.99984ZM17.5 15.8332C17.5 17.2139 16.3807 18.3332 15 18.3332C13.6193 18.3332 12.5 17.2139 12.5 15.8332C12.5 14.4525 13.6193 13.3332 15 13.3332C16.3807 13.3332 17.5 14.4525 17.5 15.8332Z' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditRows;
